import { api, getEndpoint } from "@/api";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ScoreState {
    userScore: number;
    loading: boolean;
    error: string | null;
    fetched: boolean; // ✅ Add this
    userScores: any[];
}

const initialState: ScoreState = {
    userScores: [],
    userScore: 0,
    loading: false,
    error: null,
    fetched: false, // ✅ Initialize to false
};


const scoreSlice = createSlice({
    name: "score",
    initialState,
    reducers: {
        setScore(state, action: PayloadAction<number>) {
            state.userScore = action.payload;
        },
        setUserScores(state, action: PayloadAction<any[]>) {
            state.userScores = action.payload;
        },
    },

});


export const {
    setScore: actionSetScore,
    setUserScores: actionSetUserScores, 
} = scoreSlice.actions;

export default scoreSlice.reducer;
